export default __webpack_public_path__ + "static/media/modern-design.e2114f5b.jpg";